<template>
  <div class="upload-result">
    <div class="uploadPng"></div>
    <p class="upload-tips">这里什么都没有哦</p>
    <label
      v-if="tabIndexs == 1"
      style="height: 100%; width: 100%"
      for="audio"
    >
      <div class="uploadNow">立即上传</div>
    </label>
  </div>
</template>

<script>
export default {
  name: "noUpload",
  data() {
    return {};
  },
  props: {
    tabIndexs:''
  },
  components: {},
  methods: {},
  watch: {},
  computed: {},
};
</script>

<style scoped lang="scss">
.upload-result {
 position: absolute;
 top: 133px;
 left: 50%;
 margin-left: -100px;
}
.uploadPng {
  width: 162px;
  height: 162px;
  background-image: url(../../../../static/svg/noUpload.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.upload-tips {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin-top: 20px;
}
.uploadNow {
  width: 100px;
  height: 34px;
  line-height: 34px;
  background: #5778fb;
  border-radius: 4px;
  color: #ffffff;
  margin: 20px auto 0;
  &:hover {
    opacity: 0.8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/soundtrack/noUpload.vue